import PhoneInput from "react-phone-number-input";
import fr from "react-phone-number-input/locale/fr.json";
import "react-phone-number-input/style.css";

const PhoneInputField = ({ value, onChange, required, placeholder = "Numéro de téléphone" }) => {
  return (
    <PhoneInput
      international
      defaultCountry="FR"
      labels={fr}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      className="custom-phone-input"
    />
  );
};

export default PhoneInputField;